module.exports = __webpack_public_path__ + "static/media/plate.3ab48e7e.png";